import { BottomTabRouteType } from 'utils/CustomEnums'

/**
 * 底部导航配置对象
 * 
 * 该配置对象定义了应用底部导航栏中各个标签页的配置信息，
 * 包括图标、名称、是否为外部链接以及显示顺序等属性。
 * 每个标签页通过 BottomTabRouteType 枚举值作为键进行标识。
 * 添加新的底部导航， 需要编辑 
 * 1. 在BottomTabRouteType中加入新的type
 * 2. 在app的BASIC_WEBAPP_ROUTES中，将页面加入react Router
 * 3. 如果desktop 未登录模式下，需要在顶部menu配置，在unloginCommonNavItemList中加入
 * 4. 如果desktop 未登录模式下，需要在顶部menu配置，在loginCommonNavItemList中加入
 * 5. 在mobileBottomMainNavigator中加入此navigator
 */

export const bottomNavConfig = {
    [BottomTabRouteType.BOTTOM_TAB_HOME]: {
        iconSrc: '/pageNav/homeH.png', // mobile 模式下， 底部导航的icon
        iconSrcSet: '/pageNav/homeH@2x.png, /pageNav/homeH@3x.png', // mobile 模式下， 底部导航的icon
        name: "home_home", // 底部导航，以及顶部button的名字
        external: false, // 是否需要打开新的tab
        displayOrder: 1, // 显示顺序
    },
    [BottomTabRouteType.BOTTOM_TAB_OFFER]: {
        iconSrc: '/pageNav/offerH.png',
        iconSrcSet: '/pageNav/offerH@2x.png, /pageNav/offerH@3x.png',
        name: "home_offers",
        external: false,
        displayOrder: 2,
    },
    [BottomTabRouteType.BOTTOM_TAB_FAMILY_BOOKING]: {
        iconSrc: '/pageNav/familyBookingH.png',
        iconSrcSet: '/pageNav/familyBookingH@2x.png, /pageNav/familyBookingH@3x.png',
        name: "home_family_booking",
        external: false,
        displayOrder: 3,
    },
    [BottomTabRouteType.BOTTOM_TAB_LOCATION]: {
        iconSrc: '/pageNav/storeDirectory.png',
        iconSrcSet: '/pageNav/storeDirectory@2x.png, /pageNav/storeDirectory@3x.png',
        name: "home_location",
        external: false,
        displayOrder: 4,
    },
    // [BottomTabRouteType.BOTTOM_TAB_RECORDS]: {
    //     iconSrc: '/pageNav/cartH.png',
    //     iconSrcSet: '/pageNav/cartH@2x.png, /pageNav/cartH@3x.png',
    //     name: "records:home_rewards",
    //     external: false,
    //     displayOrder: 4,
    // },
    [BottomTabRouteType.BOTTOM_TAB_PROFILE]: {
        iconSrc: '/pageNav/profileH.png',
        iconSrcSet: '/pageNav/profileH@2x.png, /pageNav/profileH@3x.png',
        name: "home_profile",
        external: false,
        displayOrder: 5,
    },
}